<template>
    <div>
        <section class="itb-graphics">
            <div class="container">
                <div class="row itb-filters">
                    <div
                        class="col-12 col-md-6 mb-4"
                        :class="{ 'col-lg-3': !isResponsive1570 }"
                        v-for="graphicCategory in graphicCategories"
                    >
                        <div class="dropdown d-block">
                            <button
                                class="btn btn-primary dropdown-toggle w-100"
                                :class="{
                                    'router-category-active': subIsActive(
                                        '/' +
                                            $t(
                                                'constants.' +
                                                    graphicCategory.alias
                                            )
                                    )
                                }"
                                type="button"
                                :id="'dropdownMenuButton' + graphicCategory.id"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                <img
                                    :src="
                                        '/images/articles/' +
                                            graphicCategory['filter_icon']
                                    "
                                    :alt="
                                        $t('constants.' + graphicCategory.name)
                                    "
                                />{{ $t("constants." + graphicCategory.name) }}
                            </button>
                            <div
                                class="dropdown-menu w-100"
                                :aria-labelledby="
                                    'dropdownMenuButton' + graphicCategory.id
                                "
                            >
                                <router-link
                                    :to="{
                                        name: 'graphicsByCategorySubcategory',
                                        params: {
                                            categoryAlias: $t(
                                                'constants.' +
                                                    graphicCategory.alias
                                            ),
                                            subcategoryAlias:
                                                graphicSubcategory.alias,
                                            scrollToElementId: 'itb-breadcrumbs'
                                        }
                                    }"
                                    @click.native="
                                        reloadSubcategories(graphicSubcategory)
                                    "
                                    :key="
                                        graphicCategory.id +
                                            graphicSubcategory.id
                                    "
                                    class="dropdown-item"
                                    v-for="graphicSubcategory in graphicCategory.graphicSubcategories"
                                >
                                    <div class="itb-image d-inline-block">
                                        <img
                                            :src="
                                                graphicSubcategory.image
                                                    ? '/uploads/' +
                                                      graphicSubcategory.image
                                                          .path +
                                                      '/' +
                                                      graphicSubcategory.image
                                                          .name
                                                    : ''
                                            "
                                            :alt="graphicSubcategory.name"
                                        />
                                    </div>

                                    {{ graphicSubcategory.name }}
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div
                        class="col-12 col-md-6 mb-4"
                        :class="{ 'col-lg-3': !isResponsive1570 }"
                    >
                        <button
                            class="btn btn-primary itb-inspirations-button w-100"
                            type="button"
                            v-if="graphicCategories.length > 0"
                            @click="goToInspirations"
                        >
                            <img
                                src="
                                        /images/articles/inspirations-icon.png
                                    "
                                :alt="$t('general.inspiration')"
                            />
                            {{ $t("general.inspiration") }}
                        </button>
                    </div>
                </div>
                <h2
                    class="text-center"
                    style="margin: 1rem 0 2.1rem 0"
                    v-if="graphicCategory.name"
                >
                    {{ $t("constants." + graphicCategory.name) }}
                    <span v-if="graphicSubcategory.name" class="itb-separator"
                        >/</span
                    >
                    <span v-if="graphicSubcategory.name">{{
                        graphicSubcategory.name
                    }}</span>
                </h2>
                <div class="row">
                    <div
                        class="col-12 col-md-6 col-lg-4"
                        v-if="graphicSubcategories2"
                        v-for="graphicSubcategory in graphicSubcategories2"
                    >
                        <div class="card w-100">
                            <div class="card-body d-flex align-items-center">
                                <div class="itb-image-wrapper text-center">
                                    <img
                                        :src="
                                            graphicSubcategory.image
                                                ? '/uploads/' +
                                                  graphicSubcategory.image
                                                      .path +
                                                  '/' +
                                                  graphicSubcategory.image.name
                                                : ''
                                        "
                                        :alt="graphicSubcategory.name"
                                    />
                                </div>
                                <h3>
                                    {{ graphicSubcategory.name }}
                                </h3>
                                <label class="itb-checkbox-label ml-auto">
                                    <input
                                        type="checkbox"
                                        v-model="filters.subcategories2"
                                        :value="graphicSubcategory.id"
                                        @change="reloadGraphicsByCheckbox"
                                    />
                                    <span class="itb-checkbox"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="!graphicSubcategory.name"
                        class="alert alert-info col-12 col-md-6 offset-md-3 col-lg-4 offset-lg-4 text-center"
                        role="alert"
                    >
                        {{ $t("graphics.please_choose_subcategory") }}
                    </div>
                </div>
                <div class="itb-filter-options form-inline">
                    <div class="d-flex align-items-center itb-order mb-4">
                        <span class="mr-4">{{ $t("graphics.order") }}:</span>
                        <span
                            style="cursor: pointer"
                            :class="[
                                'itb-link mr-3',
                                filters.order == 'A' ? 'active' : ''
                            ]"
                            @click="setOrder('A')"
                        >
                            {{ $t("graphics.alphabetical") }}</span
                        >
                        <span
                            style="cursor: pointer"
                            :class="[
                                'itb-link',
                                filters.order == 'P' ? 'active' : ''
                            ]"
                            @click="setOrder('P')"
                            >{{ $t("graphics.priority") }}</span
                        >
                    </div>
                    <div class="d-flex align-items-center mb-4">
                        <span class="mr-3">{{ $t("graphics.colors") }}:</span>
                        <div
                            class="itb-color"
                            :style="'background: ' + color.hexCode"
                            v-for="color in colors"
                            v-if="
                                color.name != 'graphic_filter_color.on_request'
                            "
                        >
                            <label class="itb-checkbox-label ml-auto">
                                <input
                                    type="checkbox"
                                    v-model="filters.colors"
                                    :value="color.id"
                                    @change="reloadGraphicsByCheckbox"
                                />
                                <span class="itb-checkbox bg-white"></span>
                            </label>
                        </div>
                    </div>
                    <div
                        class="d-flex align-items-center mb-4"
                        :class="{ 'ml-auto': !isResponsive1570 }"
                    >
                        <label for="itb-search-dropdown">
                            {{ $t("graphics.search") }}
                        </label>
                        <div class="itb-input-wrapper ml-2 mr-2">
                            <input
                                type="text"
                                :placeholder="$t('graphics.insert_search_term')"
                                v-model="filters.search"
                                class="form-control form-control-sm d-inline-block"
                                v-on:keyup.enter="searchItem"
                            />
                        </div>
                        <button
                            class="btn btn-secondary btn-sm"
                            style="box-shadow: none"
                            @click="searchItem"
                        >
                            {{ $t("graphics.search") }}
                        </button>
                        <button
                            class="btn btn-danger btn-sm ml-5"
                            style="box-shadow: none"
                            @click="cleanFilters"
                        >
                            {{ $t("graphics.clean_filters") }}
                        </button>
                    </div>
                </div>

                <div class="itb-graphics-items row" v-if="graphics.length">
                    <router-link
                        class="itb-item col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2"
                        v-lazy-container="{ selector: 'img' }"
                        v-for="graphic in graphics"
                        :key="graphic.id"
                        :to="{
                            name: 'graphicDetail',
                            params: {
                                categoryAlias: graphic.categoryAlias,
                                subcategoryAlias: graphic.subcategoryAlias,
                                subcategory2Alias: graphic.subcategory2Alias,
                                graphicAlias: graphic.id + '-' + graphic.alias
                            }
                        }"
                    >
                        <img
                            v-if="graphic.image"
                            :data-src="
                                '/uploads/' +
                                    graphic.image.path +
                                    '/' +
                                    graphic.image.name
                            "
                            :alt="graphic.name"
                        />
                        <h3>{{ graphic.name }}</h3>
                        <p>{{ graphic.description | truncate(100) }}</p>
                        <button
                            class="btn btn-primary"
                            style="max-width: 150px"
                        >
                            {{ $t("graphics.show_detail_btn") }}
                        </button>
                    </router-link>
                </div>
                <div
                    v-else
                    class="alert alert-info col-12 col-md-6 offset-md-3 col-lg-4 offset-lg-4 text-center mb-5 mt-3"
                    role="alert"
                >
                    {{ $t("graphics.no_graphics_here") }}
                </div>
                <Paginator
                    v-if="graphics.length"
                    :items="graphics"
                    :total="totalGraphics"
                    :pageNumber="pageNumber"
                    :numItemsPerPage="numItemsPerPage"
                    :loadPageLinks="loadPageLinks"
                    @getter="paginate"
                ></Paginator>
                <h3
                    class="text-center itb-other-found-title"
                    v-if="additionalGraphics.length"
                >
                    {{ $t("graphics.other_found") }}
                </h3>

                <div
                    class="itb-graphics-items row"
                    v-if="additionalGraphics.length"
                >
                    <router-link
                        class="itb-item col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2"
                        v-lazy-container="{ selector: 'img' }"
                        v-for="additionalGraphic in additionalGraphics"
                        :key="additionalGraphic.id"
                        :to="{
                            name: 'graphicDetail',
                            params: {
                                categoryAlias: additionalGraphic.categoryAlias,
                                subcategoryAlias:
                                    additionalGraphic.subcategoryAlias,
                                subcategory2Alias:
                                    additionalGraphic.subcategory2Alias,
                                graphicAlias:
                                    additionalGraphic.id +
                                    '-' +
                                    additionalGraphic.alias
                            }
                        }"
                    >
                        <img
                            v-if="additionalGraphic.image"
                            :data-src="
                                '/uploads/' +
                                    additionalGraphic.image.path +
                                    '/' +
                                    additionalGraphic.image.name
                            "
                            :alt="additionalGraphic.name"
                        />
                        <div class="itb-tag-wrapper">
                            <img
                                v-if="additionalGraphic.is_new"
                                class="itb-tag-new"
                                data-src="/images/new.png"
                                alt="new"
                            />
                            <img
                                v-if="additionalGraphic.is_bestseller"
                                class="itb-tag-bestseller"
                                data-src="/images/bestsellers.png"
                                alt="bestsellers"
                            />
                            <img
                                v-if="additionalGraphic.is_on_sale"
                                class="itb-tag-on-sale"
                                data-src="/images/sale.png"
                                alt="sale"
                            />
                        </div>

                        <h3>{{ additionalGraphic.name }}</h3>
                        <p>
                            {{ additionalGraphic.description | truncate(100) }}
                        </p>
                        <button
                            class="btn btn-primary"
                            style="max-width: 150px"
                        >
                            {{ $t("graphics.show_detail_btn") }}
                        </button>
                    </router-link>
                </div>
                <Paginator
                    v-if="additionalGraphics.length"
                    :items="additionalGraphics"
                    :total="totalAdditionalGraphics"
                    :pageNumber="additionalPageNumber"
                    :numItemsPerPage="numItemsPerPage"
                    :loadPageLinks="loadAdditionalPageLinks"
                    @getter="additionalPaginate"
                ></Paginator>
            </div>
        </section>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Paginator from "../components/Paginator";

export default {
    data() {
        return {
            page: null,
            pages: [],
            pageNumber: 1,
            numItemsPerPage: 12,
            pageParams: [],
            graphicCategories: [],
            graphicCategory: [],
            graphicSubcategory: [],
            graphicSubcategories2: [],
            colors: [],
            graphics: [],
            filters: {
                subcategories2: [],
                colors: [],
                order: "P",
                search: "",
                searchBy: "name"
            },
            totalGraphics: 0,
            loadPageLinks: false,
            additionalGraphics: [],
            totalAdditionalGraphics: 0,
            loadAdditionalPageLinks: false,
            additionalPageNumber: 1,
            additionalFilters: {},
            isResponsive1570: false
        };
    },

    mounted() {
        this.getData();
        this.onResize();

        window.addEventListener("resize", this.onResize);
    },

    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },

    components: {
        Paginator
    },

    computed: {
        ...mapGetters({
            appParams: "getAppParams"
        })
    },

    filters: {
        truncate: function(data, num) {
            const reqdString = data
                .split("")
                .slice(0, num)
                .join("");
            return reqdString + "…";
        }
    },

    methods: {
        ...mapActions(["setPageParams"]),

        getData() {
            if (this.$route.query.sc) {
                this.filters.subcategories2 = this.$route.query.sc
                    .split(",")
                    .map(Number);
            }

            if (this.$route.query.cl) {
                this.filters.colors = this.$route.query.cl
                    .split(",")
                    .map(Number);
            }

            if (this.$route.query.or) {
                this.filters.order = this.$route.query.or;
            }

            if (this.$route.query.se) {
                this.filters.search = this.$route.query.se;
            }

            if (this.$route.query.sb) {
                this.filters.searchBy = this.$route.query.sb;
            }

            this.filters.page = this.pageNumber;
            this.filters.numItemsPerPage = this.numItemsPerPage;

            let url =
                "/getGraphicsByCategoryPage/" +
                this.$route.params.categoryAlias +
                (this.$route.params.subcategoryAlias
                    ? "/" + this.$route.params.subcategoryAlias
                    : "");
            axios
                .post(url, this.filters)
                .then(response => {
                    this.pageParams = response.data.params;
                    this.graphicCategory = response.data.graphicCategory;

                    if (this.graphicCategory.graphicSubcategory) {
                        this.graphicSubcategory = this.graphicCategory.graphicSubcategory;
                        this.graphicSubcategories2 = this.graphicCategory.graphicSubcategory.graphicSubcategories2;
                    }

                    this.graphicCategories = response.data.graphicCategories;
                    this.colors = response.data.colors;
                    this.graphics = response.data.graphics;
                    this.totalGraphics = response.data.totalGraphics;
                    this.loadPageLinks = !this.loadPageLinks;
                    this.setPageParams(this.pageParams);
                    if (
                        this.filters.subcategories2.length > 0 ||
                        this.filters.colors.length > 0 ||
                        this.filters.search.length > 0
                    ) {
                        this.reloadAdditionalGraphics();
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },

        reloadGraphics(emptyQuery = false) {
            let query = {};

            if (
                this.filters.subcategories2 &&
                this.filters.subcategories2.length
            ) {
                query["sc"] = this.filters.subcategories2.join(",");
            }

            if (this.filters.colors.length) {
                query["cl"] = this.filters.colors.join(",");
            }

            if (this.filters.order != "P") {
                query["or"] = this.filters.order;
            }

            if (this.filters.search.length) {
                query["se"] = this.filters.search;
                query["sb"] = this.filters.searchBy;
            }

            if (!emptyQuery) {
                let savedQuery = {};
                savedQuery = this.$route.query;

                if (
                    Object.keys(savedQuery).length > 0 &&
                    Object.keys(query).length === 0
                ) {
                    query = savedQuery;
                }
            }

            if (this.$route.params.subcategoryAlias) {
                this.$router
                    .push({
                        name: "graphicsByCategorySubcategory",
                        params: {
                            categoryAlias: this.$route.params.categoryAlias,
                            subcategoryAlias: this.$route.params
                                .subcategoryAlias,
                            savedPosition: true
                        },
                        query: query
                    })
                    .catch(err => {});
            } else {
                this.$router
                    .push({
                        name: "graphicsByCategory",
                        params: {
                            categoryAlias: this.$route.params.categoryAlias,
                            savedPosition: true
                        },
                        query: query
                    })
                    .catch(err => {});
            }

            this.filters.page = this.pageNumber;
            this.filters.numItemsPerPage = this.numItemsPerPage;

            let url =
                "/getGraphicsByCategoryPage/" +
                this.$route.params.categoryAlias +
                (this.$route.params.subcategoryAlias
                    ? "/" + this.$route.params.subcategoryAlias
                    : "");

            axios
                .post(url, this.filters)
                .then(response => {
                    this.pageParams = response.data.params;
                    this.graphics = response.data.graphics;
                    this.graphicCategory = response.data.graphicCategory;
                    this.totalGraphics = response.data.totalGraphics;
                    this.loadPageLinks = !this.loadPageLinks;
                    this.setPageParams(this.pageParams);
                    if (
                        this.filters.subcategories2.length > 0 ||
                        this.filters.colors.length > 0 ||
                        this.filters.search.length > 0
                    ) {
                        this.reloadAdditionalGraphics();
                    } else {
                        this.additionalGraphics.splice(0);
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },

        setOrder(order) {
            if (order == this.filters.order) {
                return false;
            }

            this.filters.order = order;
            this.pageNumber = 1;
            this.additionalPageNumber = 1;
            this.reloadGraphics();
        },

        searchItem() {
            this.pageNumber = 1;
            this.additionalPageNumber = 1;
            this.reloadGraphics();
        },

        subIsActive(input) {
            const paths = Array.isArray(input) ? input : [input];
            return paths.some(path => {
                return this.$route.path.indexOf(path) > 0;
            });
        },

        reloadSubcategories(graphicSubcategory) {
            this.graphicSubcategory = graphicSubcategory;
            this.graphicSubcategories2 =
                graphicSubcategory.graphicSubcategories2;

            this.cleanFilters();
        },

        cleanFilters() {
            this.pageNumber = 1;
            this.additionalPageNumber = 1;
            this.filters = {
                subcategories2: [],
                colors: [],
                order: "P",
                search: "",
                searchBy: "name",
                page: 1
            };
            this.additionalFilters = this.filters;
            let emptyQuery = true;
            this.reloadGraphics(emptyQuery);
        },

        paginate(pageInfo = { page: this.pageNumber }) {
            this.pageNumber = pageInfo.page;
            this.reloadGraphics();
        },

        additionalPaginate(pageInfo = { page: this.additionalPageNumber }) {
            this.additionalPageNumber = pageInfo.page;
            this.reloadAdditionalGraphics();
        },

        reloadGraphicsByCheckbox() {
            this.pageNumber = 1;
            this.additionalPageNumber = 1;
            this.reloadGraphics();
        },

        reloadAdditionalGraphics() {
            var url =
                "/getAdditionalGraphicsByCategoryPage/" +
                this.$route.params.categoryAlias +
                (this.$route.params.subcategoryAlias
                    ? "/" + this.$route.params.subcategoryAlias
                    : "");
            this.additionalFilters = this.filters;
            this.additionalFilters.page = this.additionalPageNumber;
            axios
                .post(url, this.additionalFilters)
                .then(response => {
                    this.additionalGraphics = response.data.graphics;
                    this.totalAdditionalGraphics = response.data.totalGraphics;
                    this.loadAdditionalPageLinks = !this
                        .loadAdditionalPageLinks;
                })
                .catch(error => {
                    console.log(error);
                });
        },

        goToInspirations() {
            const routeData = this.$router.resolve({
                path: "/inspirace"
            });
            window.open(routeData.href, "_blank");
        },

        onResize() {
            if (window.innerWidth < 1570) {
                this.isResponsive1570 = true;
            } else {
                this.isResponsive1570 = false;
            }
        }
    }
};
</script>
